import { API_BASE_URL, getAuthHeaders } from '../../../../utils/utils';

/**
 * Fetch paginated completed GRE vocabulary articles for revision.
 * @param {Object} params
 * @param {number} [params.page=1]
 * @param {number} [params.pageSize=20]
 * @param {string} [params.difficulty]
 * @param {string} [params.q]
 * @param {string} [params.sort='newest']
 */
export const fetchArticleHistory = async ({
  page = 1,
  pageSize = 20,
  difficulty,
  q,
  sort = 'newest',
} = {}) => {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('page_size', String(pageSize));
  params.set('sort', sort);
  if (difficulty) {
    params.set('difficulty', difficulty);
  }
  if (q && q.trim()) {
    params.set('q', q.trim());
  }

  const response = await fetch(
    `${API_BASE_URL}/api/gre/articles/history?${params.toString()}`,
    {
      method: 'GET',
      headers: getAuthHeaders(),
    }
  );

  if (!response.ok) {
    let detail = `Failed to load article history (${response.status})`;
    try {
      const body = await response.json();
      if (body?.detail) {
        detail = typeof body.detail === 'string' ? body.detail : detail;
      }
    } catch {
      // ignore parse errors
    }
    const error = new Error(detail);
    error.status = response.status;
    throw error;
  }

  return response.json();
};
